import { makeStyles } from "@material-ui/core";
import { COLORS } from "../../config/theme/theme";

const ruleEngineStyles = makeStyles({
  root: {
    marginTop: "80px",
    padding: "24px 24px 24px 24px",
  },
  dFlexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  headerRoot: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 600,
    fontSize: "24px",
    color: COLORS.DARK_GRAY,
  },
  backButtonStyles: {
    width: "auto",
    height: "40px",
    background: "#0E5AA7",
    color: "#FFFFFF",
    border: "1px solid #0E5AA7",
    borderRadius: "4px",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "20px",
    "&:hover": {
      backgroundColor: "#0E5AA7",
      color: "#FFFFFF",
      border: "1px solid #0E5AA7",
      borderRadius: "8px",
    },
  },
  footerDivStyle: {
    display: "flex",
    justifyContent: "space-between",
    margin: 0,
    padding: "24px 0px 0px 0px",
  },
  buttonStyle: {
    width: "220px",
    borderRadius: "4px",
  },
  cancelConfigStyle: {
    width: "220px",
    background: "#FFFFFF",
    border: "1px solid #0E5AA7",
    borderRadius: "4px",
    color: "#0E5AA7",
    textDecoration: "none",
    textTransform: "none",
    marginRight: "24px",
    "&:hover": {
      background: "#FFFFFF",
      border: "1px solid #0E5AA7",
    },
    "&.MuiButton-label": {
      background: "#FFFFFF",
      border: "1px solid #0E5AA7",
      "&:hover": {
        background: "#FFFFFF",
        border: "1px solid #0E5AA7",
      },
    },
  },
  resetConfigStyle: {
    width: "220px",
    background: "#FFFFFF",
    border: "1px solid",
    borderColor: COLORS.DOS_BLUE_DARK,
    borderRadius: "4px",
    color: COLORS.DOS_BLUE_DARK,
    textDecoration: "none",
    textTransform: "none",
    marginRight: "24px",
    "&:hover": {
      background: "#FFFFFF",
      border: "1px solid",
      borderColor: COLORS.DOS_BLUE_DARK,
    },
    "&.MuiButton-label": {
      background: "#FFFFFF",
      border: "1px solid",
      borderColor: COLORS.DOS_BLUE_DARK,
      "&:hover": {
        background: "#FFFFFF",
        border: "1px solid",
        borderColor: COLORS.DOS_BLUE_DARK,
      },
    },
  },
  accessConfigStyle: {
    margin: "auto 0px",
    padding: 0,
  },
  accessConfigTextStyle: {
    fontSize: "12px",
    color: COLORS.DARK_RED,
    fontWeight: 400,
    textAlign: "end",
  }
});

export default ruleEngineStyles;
